export const COMETCHAT_CONSTANTS = {
  APP_ID: '199923bc66f712fe',
  REGION: 'eu',
  AUTH_KEY: '570e37b99f58e6b5afc11424fecbc8742cdb56c0',
};
